import styled from "styled-components";

export const NotFormContainer = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #e5e5e5;
  z-index: 999;
`;
